import styled from "styled-components";

import { device } from "utils/sizes";

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    align-self: center;
    width: 100%;
    ${device.xl} {
        width: 90%;
    }
    min-height: calc(100vh - (5rem + 8rem));
`;
